<script lang="ts" setup>
import { MatePersona } from "@/types/chat";
import { useMate } from "@/stores/mate";
import { replacePlaceHolder } from "@/components/mobile/chat/mode/util";

const props = withDefaults(
  defineProps<{
    selected?: boolean;
    matePersona: MatePersona;
    targetMate?: Mate;
  }>(),
  {
    selected: false,
  }
);

const mateStore = useMate();
</script>
<template>
  <AuthLock>
    <div
      :class="{
        '': !selected,
        'border-primary': selected,
      }"
      class="flex gap-2 border p-2 h-32 rounded cursor-pointer"
    >
      <div
        v-if="matePersona.icon"
        :class="{
          'text-primary': selected,
        }"
        class="h-28 shrink-0 aspect-[3/4] flex items-center justify-center bg-neutral rounded-lg"
      >
        <i v-if="matePersona.icon" :class="matePersona.icon" />
      </div>
      <UserAvatar
        v-else
        :avatar-url="matePersona.media?.url"
        class="h-28 shrink-0"
      />
      <div class="overflow-y-auto flex-grow text-xs flex flex-col gap-1">
        <div class="text-xs line-clamp-3 sm:line-clamp-3 shrink-0">
          <span class="text-base-content/50">
            {{ $t("Chats.matePersona.name") }}:
          </span>
          {{ matePersona.name }}
        </div>
        <div class="text-xs">
          <span class="text-base-content/50">
            {{ $t("Chats.matePersona.description") }}:
          </span>
          {{
            targetMate
              ? replacePlaceHolder(
                  matePersona.description,
                  targetMate.name,
                  mateStore.currentMate?.name
                )
              : matePersona.description
          }}
        </div>
      </div>
    </div>
  </AuthLock>
</template>
